<template>
  <div>
    <van-field
      v-model="info.姓名"
      name="姓名"
      label="姓名"
      placeholder="请输入姓名"
      :rules="[{ required: true, message: '姓名不能为空' }]"
    />

    <van-field
      v-model="info.出生日期"
      readonly
      clickable
      name="tel"
      label="出生日期"
      placeholder="选择出生日期"
      @click="$emit('showDatePup', '出生日期')"
      :rules="[{ required: true, message: '请选择出生日期' }]"
    />
    <van-field name="性别" label="性别">
      <template #input>
        <van-radio-group v-model="info.性别" direction="horizontal">
          <van-radio name="男">男</van-radio>
          <van-radio name="女">女</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field
      v-model="info.民族"
      readonly
      clickable
      name="tel"
      label="民族"
      placeholder="民族"
      @click="$emit('ShowPopup', '民族')"
      :rules="[{ required: true, message: '请选择民族' }]"
    />
    <van-field
      readonly
      clickable
      :required="true"
      :value="info.社团职务"
      label="社团职务"
      placeholder="请选择社团职务"
      @click="$emit('ShowPopup', '社团职务')"
    />

    <!-- <van-field name="社团职务" label="社团职务">
      <template #input>
        <van-radio-group v-model="info.社团职务">
          <van-radio name="0">系统主席/副主席</van-radio>
          <van-radio name="1">社团主席/副主席</van-radio>
          <van-radio name="2">部长/副部长</van-radio>
          <van-radio name="3">班长/团支书</van-radio>
          <van-radio name="4">其他</van-radio>
        </van-radio-group>
      </template>
    </van-field> -->

    <van-field
      v-model="info.身高"
      name="身高"
      label="身高"
      type="digit"
      placeholder="请输入身高(厘米)"
    />

    <van-field
      v-model="info.体重"
      name="体重"
      label="体重"
      type="number"
      placeholder="请输入体重(公斤)"
    />

    <van-field
      readonly
      clickable
      :required="true"
      :value="info.证件类型"
      label="证件类型"
      placeholder="请选择"
      @click="$emit('ShowPopup', '证件类型')"
    />
    <van-field
      v-model="info.证件号码"
      type="text"
      name="tel"
      label="证件号码"
      placeholder="请填写证件号码"
      :rules="[{ required: true, message: '请填写证件号码' }]"
    />
    <van-field
      readonly
      clickable
      :value="info.政治面貌"
      label="政治面貌"
      placeholder="政治面貌"
      @click="$emit('ShowPopup', '政治面貌')"
      :rules="[{ required: true, message: '请选择政治面貌' }]"
    />

    <van-field
      v-model="info.籍贯"
      readonly
      clickable
      label="籍贯"
      placeholder="籍贯"
      @click="$emit('ShowArea', '籍贯')"
      :rules="[{ required: true, message: '请填写籍贯' }]"
    />

    <van-field
      v-model="info.现居住地"
      readonly
      clickable
      label="现居住地"
      placeholder="现居住地"
      @click="$emit('ShowArea', '现居住地')"
      :rules="[{ required: true, message: '请填写现居住地' }]"
    />
    <van-field
      v-model="info.邮箱"
      type="text"
      name="tel"
      label="邮箱"
      placeholder="电子邮箱"
      :rules="[{ required: true, message: '请填写电子邮箱' }]"
    />

    <van-field
      v-model="info.电话"
      type="text"
      name="电话"
      label="电话"
      placeholder="请填写电话"
      :rules="[{ required: true, message: '请填写电话' }]"
    />

    <van-field
      v-model="info.紧急联系人"
      type="text"
      label="紧急联系人"
      placeholder="紧急联系人"
      :rules="[{ required: true, message: '请填写电话' }]"
    />

    <van-field
      v-model="info.紧急联系人电话"
      type="tel"
      label="电话"
      placeholder="紧急联系人电话"
      :rules="[{ required: true, message: '请填写紧急联系人电话' }]"
    />
    <van-field
      readonly
      clickable
      :value="info.最高学历"
      label="最高学历"
      placeholder="最高学历"
      @click="$emit('ShowPopup', '最高学历')"
      :rules="[{ required: true, message: '请选择最高学历' }]"
    />

    <van-field
      v-model="info.毕业院校"
      type="text"
      name="tel"
      label="毕业院校"
      placeholder="毕业院校"
      :rules="[{ required: true, message: '毕业院校' }]"
    />
    <van-field
      readonly
      clickable
      :value="info.专业成绩排名"
      label="专业成绩排名"
      placeholder="专业成绩排名"
      @click="$emit('ShowPopup', '专业成绩排名')"
      :rules="[{ required: true, message: '专业成绩排名' }]"
    />
    <van-field
      v-model="info.专业"
      type="text"
      label="专业"
      placeholder="专业"
      :rules="[{ required: true, message: '请填写专业' }]"
    />
    <van-field
      readonly
      clickable
      :value="info.英语等级"
      label="英语等级"
      placeholder="英语等级"
      @click="$emit('ShowPopup', '英语等级')"
      :rules="[{ required: true, message: '请选择英语等级' }]"
    />

    <van-field
      v-model="info.资格证书"
      type="text"
      name="tel"
      label="资格证书"
      placeholder="资格证书"
      :rules="[{ required: true, message: '请资格证书' }]"
    />
    <van-field
      readonly
      clickable
      :value="info.意向工作地一"
      label="意向工作地一"
      placeholder="意向工作地一"
      @click="$emit('ShowPopup', '意向工作地', '1')"
      :rules="[{ required: true, message: '请选择意向工作地二' }]"
    />
    <van-field
      readonly
      clickable
      :value="info.意向工作地二"
      label="意向工作地二"
      placeholder="意向工作地二"
      @click="$emit('ShowPopup', '意向工作地', '2')"
      :rules="[{ required: true, message: '请选择意向工作地二' }]"
    />

    <van-field type="text" name="tel" label="是否服从分配">
      <template #input>
        <van-radio-group v-model="info.是否服从分配" direction="horizontal">
          <van-radio name="是">是</van-radio>
          <van-radio name="否">否</van-radio>
        </van-radio-group>
      </template>
    </van-field>

    <van-field
      readonly
      clickable
      :value="info.招聘信息来源"
      label="招聘信息来源"
      placeholder="招聘信息来源"
      @click="$emit('ShowPopup', '招聘信息来源')"
      :rules="[{ required: true, message: '请选择招聘信息来源' }]"
    />

    <!-- https://img01.yzcdn.cn/vant/cat.jpeg" -->

    <!-- <van-field name="uploader" label="证件照上传">
      <template #input>
        <van-uploader
          v-model="fileList"
          :after-read="afterRead"
          multiple
          :max-count="1"
        />
      </template>
    </van-field> -->

    <van-field name="uploader" label="证件照上传">
      <template #input>
        <van-image
          v-if="info.证件照片"
          @click="
            info.证件照片 = null;
            fileList = [];
          "
          width="100"
          height="100"
          :src="$request.imgpath(info.证件照片)"
        />
        <van-uploader
          v-else
          v-model="fileList"
          :after-read="afterRead"
          multiple
          :max-count="1"
        />
      </template>
    </van-field>

    <van-field type="text" name="tel" label="隐私声明">
      <template #input>
        <van-checkbox v-model="info.隐私声明"
          >我已阅读并同意以下隐私内容</van-checkbox
        >
      </template>
    </van-field>
    <van-cell>
      <div>
        失业隐私声明内容：本人承诺，本表所填内容均真实有效，如有虚假，本人愿意承担一切责任。本人愿意配合核实信息。
      </div>
    </van-cell>
    
      <div style="margin: 16px">
        <van-row>
          <van-col span="8"
            ><van-button round block @click.prevent="$emit('handlerStep','-1')"
              >取消</van-button
            >
          </van-col>
          <van-col span="8">
            
          </van-col>
          <van-col span="8">
            <van-button  round block @click.prevent="$emit('handlerStep','1')"
              >下一步</van-button
            >
          </van-col>
        </van-row>
      </div>

  </div>
</template>
<script>
export default {
  name: "baseinfo",
  props: ["info"],
  data() {
    return {
      fileList: [],
    };
  },
  methods: {
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";

      this.$request
        .UploadImg({
          content: file.content,
          id: "resume_" + this.info.证件号码,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.$set(this.info, "证件照片", res.data.fid);
            file.status = "";
            file.message = "";
          } else {
          }
          //  console.log(res)
          //  this.img=this.$request.ImgUrl(res.data.fid)
          //  console.log(this.img)
          //   //this.fileList=[{url: this.img}]
          //  file.status = "";
          // file.message = "";
        });
    },
  },
};
</script>
<style scoped>
.prop {
  font-size: 12px;

  background-color: chocolate;
  color: cadetblue;
}
</style>
